exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.categories-table{height:75vh;font-size:9pt}.categories-table .categories-table-style-actions{min-width:120px}.categories-table .categories-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.categories-table .categories-table-style-phone{min-width:105px}.categories-table .categories-table-style-th-datetime{min-width:110px}.categories-table .categories-table-style-td-datetime{text-align:center}", ""]);

// exports
